import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=ca9dc622&scoped=true&"
import script from "./Invite.vue?vue&type=script&lang=ts&"
export * from "./Invite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9dc622",
  null
  
)

export default component.exports